import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdKeyboardArrowRight } from 'react-icons/md';
import SummaryApi from '../../common';

const AddDepartment = () => {
    const [formData, setFormData] = useState({
        deptName: '',
        deptHead: '',
        building: '',
        officeNumber: '',
        email: '',
        budget: '',
        description: '',
        photo: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleFileChange = (e) => {
        setFormData({
            ...formData,
            photo: e.target.files[0]
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { deptName, deptHead, building, officeNumber, email, budget, description, photo } = formData;

        // Create FormData object to send the data
        const data = new FormData();
        data.append("department_name", deptName);
        data.append("department_head", deptHead);
        data.append("building", building);
        data.append("office_number", officeNumber);
        data.append("email", email);
        data.append("budget", budget);
        data.append("description", description);
        if (photo) {
            data.append("department_image", photo);
        }
        data.append("is_active", "1"); // Assuming the department is active when it's created
        data.append("created_date", new Date().toISOString());

        // Send data to the backend using fetch
        try {
            const response = await fetch(SummaryApi.createDepartment.url, {
                method: 'POST',
                body: data,
            });

            const result = await response.json();

            if (response.ok) {
                // Handle successful response
                console.log("Department created successfully:", result);
                // Optionally, you could redirect or clear the form here
                handleReset();
            } else {
                console.error("Error creating department:", result);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleReset = () => {
        setFormData({
            deptName: '',
            deptHead: '',
            building: '',
            officeNumber: '',
            email: '',
            budget: '',
            description: '',
            photo: null,
        });
    };

    return (
        <div className="">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-semibold mb-4 text-center sm:text-left">
                Departments
            </h1>

            <nav className="text-gray-600 mb-4">
                <ol className="flex flex-wrap items-center space-x-2 text-sm sm:text-base">
                    <li>
                        <Link to="/dashboard" className="hover:text-[#ffa404]">
                            Home
                        </Link>
                    </li>
                    <li className="text-[#ffa404]">
                        <MdKeyboardArrowRight size={25} />
                    </li>
                    <li className="text-[#ffa404]">
                        <Link to="/adddepartment" className="hover:text-[#ffa404]">
                            Add New Department
                        </Link>
                    </li>
                </ol>
            </nav>

            <div className="bg-white shadow-md rounded-lg p-6 mt-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center sm:text-left">
                    Add New Department
                </h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {/* Department Name */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Department Name*</label>
                            <input
                                type="text"
                                name="deptName"
                                value={formData.deptName}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Department Head */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Department Head*</label>
                            <input
                                type="text"
                                name="deptHead"
                                value={formData.deptHead}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Building */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Building*</label>
                            <input
                                type="text"
                                name="building"
                                value={formData.building}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Office Number */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Office Number*</label>
                            <input
                                type="text"
                                name="officeNumber"
                                value={formData.officeNumber}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Email */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">E-Mail*</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Budget */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Budget*</label>
                            <input
                                type="number"
                                name="budget"
                                value={formData.budget}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Description */}
                        <div className="col-span-1 sm:col-span-2 lg:col-span-3">
                            <label className="block text-[16px] font-medium text-gray-500">Description*</label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            ></textarea>
                        </div>

                        {/* Photo */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Upload Photo*</label>
                            <input
                                type="file"
                                name="photo"
                                onChange={handleFileChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row space-x-0 sm:space-x-4 mt-4">
                        <button
                            type="submit"
                            className="p-4 bg-[#ffa404] text-white rounded-md hover:bg-[#e89d02] flex items-center justify-center"
                        >
                            Save
                        </button>
                        <button
                            type="button"
                            onClick={handleReset}
                            className="p-4 bg-gray-300 text-black rounded-md hover:bg-gray-400 flex items-center justify-center mt-4 sm:mt-0"
                        >
                            Reset
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddDepartment;
